import Image from '@tiptap/extension-image';
export default Image.extend({
  addAttributes() {
    return {
      src: {
        default: ''
      },
      alt: {
        default: undefined
      },
      title: {
        default: undefined
      },
      height: {
        default: undefined
      },
      width: {
        default: undefined
      }
    };
  }
});